import React from "react";
import { useParams } from "react-router-dom";
import AddNewPerformance from "./AddNewPerformance";
import AddBreadCrumb from "./AddBreadCrumb";

function AddPerformDataPage() {
  const { cogen_id } = useParams(); // 👈 extract cogen_id from URL

  return (
    <div className="container-fluid">
      <AddBreadCrumb />
      <AddNewPerformance cogen_id={cogen_id} /> {/* 👈 pass it down */}
    </div>
  );
}

export default AddPerformDataPage;
